import { t } from "i18next";

import { FieldBuilder, MultiPageFormBuilder } from "../../formBuilder/index.js";
import { emailSchema } from "../../types/index.js";
import { tk } from "../../types/Translation.js";

export const formSpecification = new MultiPageFormBuilder()
  .withFieldAlwaysVisible({
    fieldName: "email",
    type: "textbox",
    label: tk("shareIncident.title"),
    ...new FieldBuilder().withSchema(emailSchema).build(),
  })
  .withPage(["email"])
  .build({ t });

export type ShareIncidentFormData = ReturnType<
  typeof formSpecification
>["formType"];
